<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div class="back_left" @click="$router.go(-1)"></div>
      <div class="big_tit">{{$t('safe.aboutUs')}}</div>
    </div>
    <div class="wrap_box">
      <router-link to="/about/4" class="item">
        <img src="../images/user/account/icon2.png" alt="">
        <div class="left">
          <span class="icon icon_greement"></span>
          <span class="info">{{$t('safe.companyProfile')}}</span>
        </div>
        <div class="right icon_right"></div>
      </router-link>
      <router-link to="/about/12" class="item">
        <img src="../images/user/account/icon6.png" alt="">
        <div class="left">
          <span class="icon icon_greement"></span>
          <span class="info">{{$t('index.agreement')}}</span>
        </div>
        <div class="right icon_right"></div>
      </router-link>
      <router-link to="/about/13" class="item">
        <img src="../images/user/account/icon7.png" alt="">
        <div class="left">
          <span class="icon icon_policy"></span>
          <span class="info">{{$t('index.secret')}}</span>
        </div>
        <div class="right icon_right"></div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutUs',
  created() {
    this.$parent.footer('user', false);
  }
}
</script>

<style lang="less" scoped>
.big_tit{ color:#fff; }
.wrap_box{
  display:flex;
  flex-direction:column;
  align-items:center;
  .item{
    height:40px;
    width:100%;
    padding:10px 15px;
    border-bottom:1px solid #ECECEC;
    font-size:14px;
    color:rgba(0,0,0,.8);
    line-height:20px;
    display:flex;
    align-items:center;
    img{ width:17px; height:17px; margin-right:8px; }
    .left{ flex:1; }
    .right{ width:20px; height:20px; background:url(../images/user/arrow.png) no-repeat center center; background-size:100% 100%; }
  }
}
</style>
